import { ClassConstructor } from "class-transformer";
import { DatabaseUser } from "src/modules/database/shared/database-user.entity";
import { LoginUserDatabase } from "src/modules/database/shared/login-user-database.model";
import { Utils } from "src/modules/utils/shared/utils";
import { DatabaseUserGroup } from 'src/modules/database/shared/database-user-group.model';

export class LoginUser {
    constructor(public userName: string, public access_token: string, public additional: any) {
    }

    getAdditional<T extends object>(key: string, type: ClassConstructor<T>): T {
        return this.additional == null ? null : Utils.fromPlainUnsafe(type, this.additional[key]);
    }

    getDatabaseUser(): DatabaseUser {
        return Utils.fromPlainUnsafe(DatabaseUser, this.getAdditional("database", LoginUserDatabase)?.raw);
    }

    getUserGroups(): DatabaseUserGroup[] {
        return this.getDatabaseUser()?.groups;
    }

}
